import { isNOU, guid } from "@ms-ofb/officefloodgatecore/dist/src/Utils";
import * as Logging from "../Logging/Logging";
import "../Polyfills/Fetch";
import { TargetedMessagingTransport } from "@ms-ofb/officepersonalization/dist/lib/TargetedMessaging/TargetedMessagingTransport";

export class DynamicContentTransport extends TargetedMessagingTransport {
	public requestId: string;

	constructor() {
		super();
	}

	public postRequestWithRetry(requestUrl: string, body: string, retry: number, timeout: number): Promise<Response> {
		return new Promise((resolve, reject) => {
			this.sendPostRequest(requestUrl, body, undefined, undefined, true, timeout)
				.then(resolve)
				.catch((error) => {
					Logging.getLogger().logEvent(
						Logging.EventIds.DYNAMICTRANSPORT_POST_ERROR,
						Logging.LogLevel.Error,
						{
							ErrorMessage: error.toString(),
							TimeMilliseconds: timeout,
							Count: retry,
							CorrelationId: this.requestId,
						});

					if (retry <= 1) {
						return reject(error);
					}
					this.postRequestWithRetry(requestUrl, body, retry - 1, timeout)
						.then(resolve)
						.catch(reject);
				});
		});
	}

	protected createHeaders(token?: string): Headers {
		const headers: Headers = typeof Headers !== "undefined" && new Headers();

		if (headers) {
			this.createNormalHeaders(headers);

			// Governance Service doesn't need to use token for now
			if (!isNOU(token)) {
				headers.append("Authorization", "Bearer " + token);
			}
		}
		return headers;
	}

	private createNormalHeaders(headers: Headers) {
		this.requestId = guid();
		headers.append("X-Request-ID", this.requestId);
		headers.append("Content-Type", "application/json");
	}
}
